import { isRecord } from './keyValueObject';

class LRUCache<K, T extends {}> {
  limit: number;
  cache: Map<K, T>;
  constructor(limit = 50) {
    this.limit = limit;
    this.cache = new Map();
  }

  get(key: K) {
    if (!this.cache.has(key)) {
      return null;
    }
    // 가장 최근에 사용된 항목으로 업데이트
    const value = this.cache.get(key) as T;
    this.cache.delete(key);
    this.cache.set(key, value);
    return value;
  }

  add(key: K, value: T) {
    if (this.cache.has(key)) {
      const oldValue = this.cache.get(key);

      if (isRecord(oldValue)) {
        const newValue = {
          ...oldValue,
          ...value,
        };

        this.cache.set(key, newValue);

        return;
      }
    }

    if (this.cache.size === this.limit) {
      // 가장 오래된 항목 제거
      const oldestKey = this.cache.keys().next().value as K;
      this.cache.delete(oldestKey);
    }

    this.cache.set(key, value);
  }

  addMap(map: Map<K, T>) {
    map.forEach((value, key) => {
      this.add(key, value);
    });
  }

  set(array: [K, T][]) {
    this.cache = new Map(array);
  }

  delete(key: K) {
    if (this.cache.has(key)) {
      this.cache.delete(key);
    }
  }

  length() {
    return this.cache.size;
  }

  clear() {
    this.cache.clear();
  }

  clone() {
    const res = new LRUCache<K, T>(this.limit);
    res.addMap(this.cache);
    return res;
  }
}

export default LRUCache;
